/**
 * H5的播放层消息通信器(和互动层通信, 互动层使用ChildBridge接收)
 */
import { ChannelMessage, IParentBridge, CompsNameSpace } from '../ChannelMessage';
import { stackItem, classTracker, trackerEnv, trackerCb } from '@iv/shared/src/tracker';

@classTracker(false, trackerEnv.parent, ['init'])
export default class ParentBridge implements IParentBridge {
  private iframe: any;
  private iframeContainer: any;
  private handle: (param: ChannelMessage) => any;
  private msgHandle: (...args: any[]) => void;

  public constructor({ iframe, iframeContainer }: { iframe: any; iframeContainer: any }) {
    this.iframe = iframe;
    this.iframeContainer = iframeContainer;
    this.msgHandle = async ({ data, source }: { data: ChannelMessage; source: any }) => {
      if (source === this.iframe.contentWindow && data.ns && this.handle) {
        if (data.ns === CompsNameSpace.tracker && data.method === 'send') {
          trackerCb(data.data as stackItem[], data.isEnd);
          return;
        }

        const retMessage: ChannelMessage = {
          nodeId: data.nodeId,
          ns: data.ns,
          method: data.method,
          data: '',
          seq: data.seq,
        };
        try {
          retMessage.data = await this.handle(data);
        } catch (err) {
          retMessage.data = err;
          retMessage.type = 'reject';
        }

        this.send(retMessage);
      }
    };
    window.addEventListener('message', this.msgHandle);
  }

  public init(cb: (param: ChannelMessage) => any) {
    this.handle = cb;
  }

  public send(data: ChannelMessage) {
    if (this.iframe.contentWindow) {
      this.iframe.contentWindow.postMessage(data, '*');
    }
  }

  public show() {
    this.iframeContainer.style.zIndex = '';
  }

  public hide() {
    this.iframeContainer.style.zIndex = '-1000';
  }

  public destroy() {
    // 移除原来的互动层
    this.iframe?.parentElement.remove();
    this.iframe?.remove();
    window.removeEventListener('message', this.msgHandle);
  }
}
